import { createContext } from 'react';

type PreventUpdatingContext = {
  preventUpdate: (apiCall: () => Promise<unknown>) => Promise<void>;
  isUpdating: boolean;
};

export const PreventUpdatingContext = createContext({} as PreventUpdatingContext);
